import cx from 'classnames';
import React, { ReactElement, ReactNode } from 'react';

/**
 * Shared width for one control in a filter bar; also caps the dropdown panel, which anchors to it.
 * `wide` is for pickers listing people's names, which do not fit the default.
 */
export const FilterField = ({
  children,
  wide,
  className,
}: {
  children: ReactNode;
  wide?: boolean;
  className?: string;
}): ReactElement => (
  <div className={cx('w-full min-w-0', wide ? 'sm:max-w-[240px]' : 'sm:max-w-[180px]', className)}>{children}</div>
);
